import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <section className="success" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2>Page Not Found</h2>
            <hr className="star-primary" />
            <p>The page you're looking for doesn't exist.</p>
            <Link to="/title" className="btn btn-primary">
              Go Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound; 